var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "icon_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      [
        _c(
          "el-form-item",
          {
            staticClass: "type_wrap",
            attrs: {
              prop: "type",
              rules: [
                { required: true, message: "请选择类型", trigger: "change" },
              ],
            },
          },
          [
            _c("div", { staticClass: "label" }, [_vm._v(" 选择类型 ")]),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeType },
                    model: {
                      value: _vm.value.config.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "type", $$v)
                      },
                      expression: "value.config.type",
                    },
                  },
                  _vm._l(
                    _vm.value.config_default_value.typeList,
                    function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "type_box" },
                        [
                          _c("el-image", {
                            staticClass: "img",
                            attrs: { src: item.imageurl, fit: "contain" },
                            on: {
                              click: function ($event) {
                                return _vm.changeType(item.id)
                              },
                            },
                          }),
                          _c("el-radio", { attrs: { label: item.id } }, [
                            _vm._v(_vm._s(_vm._f("idFormat")(item.id))),
                          ]),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "addFormItem" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("是否开启动态标签")]),
            _c(
              "el-form-item",
              {
                staticStyle: { margin: "0" },
                attrs: {
                  prop: "enable_dynamic_tags",
                  rules: [
                    { required: true, message: "请选择", trigger: "change" },
                  ],
                },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.enable_dynamic_tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "enable_dynamic_tags", $$v)
                      },
                      expression: "value.config.enable_dynamic_tags",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "0" } }, [
                      _vm._v("不开启"),
                    ]),
                    _c("el-radio", { attrs: { label: "1" } }, [_vm._v("开启")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            attrs: {
              prop: "title",
              rules: [
                {
                  max: 20,
                  message: "标题过长，最多20个字",
                  trigger: "change",
                },
              ],
            },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("金刚区标题")]),
            _c("el-input", {
              attrs: { clearable: "" },
              model: {
                value: _vm.value.config.title,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.value.config,
                    "title",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "value.config.title",
              },
            }),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            staticClass: "addFormItem",
            attrs: {
              prop: "title_position",
              rules: [
                { required: true, message: "选项不可为空", trigger: "change" },
              ],
            },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("标题位置")]),
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.value.config.title_position,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "title_position", $$v)
                  },
                  expression: "value.config.title_position",
                },
              },
              [
                _c("el-radio", { attrs: { label: "left" } }, [_vm._v("居左")]),
                _c("el-radio", { attrs: { label: "center" } }, [
                  _vm._v("居中"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            staticClass: "addFormItem",
            attrs: {
              prop: "bg_style",
              rules: [
                { required: true, message: "选项不可为空", trigger: "change" },
              ],
            },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("组件边框和背景色")]),
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.value.config.bg_style,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "bg_style", $$v)
                  },
                  expression: "value.config.bg_style",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "radio-box" },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("无边框，背景色跟页面一致"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "radio-box" },
                  [
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("有边框，独立设置背景色"),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _vm.value.config.bg_style === 2
          ? [
              _c(
                "el-form-item",
                {
                  staticClass: "addFormItem",
                  attrs: {
                    prop: "bg_color",
                    rules: [
                      {
                        required: true,
                        message: "背景色不可为空",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("背景色")]),
                  _c("el-color-picker", {
                    model: {
                      value: _vm.value.config.bg_color,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "bg_color", $$v)
                      },
                      expression: "value.config.bg_color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "addFormItem",
                  attrs: {
                    prop: "border_style",
                    rules: [
                      {
                        required: true,
                        message: "背景色不可为空",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("边框显示和隐藏"),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.changeBorderStyle },
                          model: {
                            value: _vm.value.config.border_style,
                            callback: function ($$v) {
                              _vm.$set(_vm.value.config, "border_style", $$v)
                            },
                            expression: "value.config.border_style",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "radio-box" },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("显示全部边框"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "radio-box" },
                            [
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("隐藏部分边框"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "border_none_box",
                          class: _vm.getBorderBoxClass,
                        },
                        _vm._l(4, function (line) {
                          return _c("div", {
                            key: line,
                            class: [
                              "line",
                              "line" + line,
                              _vm.value.config.border_style === "2" &&
                                "pointer",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeLine(line)
                              },
                            },
                          })
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tips hide-border" }, [
                    _vm._v(
                      " 隐藏某条边框时，与之相连的圆角将变为直角，比如隐藏下方边框，左下方和右下方的圆角会变成直角。 "
                    ),
                  ]),
                ]
              ),
              _c("el-form-item", { attrs: { prop: "bg_image" } }, [
                _c("div", { staticClass: "label" }, [_vm._v("底部背景图")]),
                _c("div", { staticClass: "bg-upload-box" }, [
                  _c("div", { staticClass: "upload-item-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("upload-file", {
                          ref: "uploadBG",
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: _vm.value.config.bg_image,
                            canDel: Boolean(_vm.value.config.bg_image),
                            deletePadding: true,
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            onDelete: _vm.deleteImg,
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(
                                res,
                                _vm.value.config,
                                "bg_image"
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload("uploadBG")
                              },
                            },
                          },
                          [_vm._v("上传图片")]
                        ),
                        _vm.pictureInfo[2]
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(2, "bg_image")
                                  },
                                },
                              },
                              [_vm._v("选择图片")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]
          : _vm._e(),
        _c(
          "div",
          { staticClass: "addFormItem" },
          [
            _c("div", { staticClass: "title" }, [_vm._v(" 文字大小和颜色 ")]),
            _c(
              "el-form-item",
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.activeText,
                      callback: function ($$v) {
                        _vm.activeText = $$v
                      },
                      expression: "activeText",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "title" } }, [
                      _vm._v("标题"),
                    ]),
                    _c("el-radio-button", { attrs: { label: "category" } }, [
                      _vm._v("分类名称"),
                    ]),
                    _c("el-radio-button", { attrs: { label: "tag" } }, [
                      _vm._v("动态标签"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.activeText === "title"
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: "字号" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 0 },
                        model: {
                          value: _vm.value.config.title_font_size,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "title_font_size", $$v)
                          },
                          expression: "value.config.title_font_size",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "颜色" } },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.value.config.title_color,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "title_color", $$v)
                          },
                          expression: "value.config.title_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.activeText === "category"
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: "字号" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 0 },
                        model: {
                          value: _vm.value.config.category_font_size,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value.config,
                              "category_font_size",
                              $$v
                            )
                          },
                          expression: "value.config.category_font_size",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "颜色" } },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.value.config.category_color,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "category_color", $$v)
                          },
                          expression: "value.config.category_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.activeText === "tag"
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: "字号" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 0 },
                        model: {
                          value: _vm.value.config.tag_font_size,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "tag_font_size", $$v)
                          },
                          expression: "value.config.tag_font_size",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "颜色" } },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.value.config.tag_color,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "tag_color", $$v)
                          },
                          expression: "value.config.tag_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _c(
          "el-form-item",
          {
            staticClass: "addFormItem",
            attrs: {
              prop: "cols",
              rules: [
                { required: true, message: "列数不可为空", trigger: "change" },
              ],
            },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("单屏显示列数")]),
            _c("div", { staticClass: "tips" }, [
              _vm._v(
                " 5列（96*96）用于金刚区独立使用，5列（84*84）用于跟四列金刚区混合使用 "
              ),
            ]),
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: { disabled: _vm.value.config.type === 3 },
                model: {
                  value: _vm.value.config.cols,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "cols", $$v)
                  },
                  expression: "value.config.cols",
                },
              },
              _vm._l(_vm.colsList, function (col) {
                return _c("el-option", {
                  key: col.value,
                  attrs: { label: col.label, value: col.value },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "el-form-item",
          {
            staticClass: "addFormItem",
            attrs: {
              prop: "total_cols",
              rules: [
                {
                  required: true,
                  validator: function (rule, val, callback) {
                    return _vm.checkTotalCols(
                      rule,
                      val,
                      _vm.value.config.cols,
                      callback
                    )
                  },
                },
              ],
            },
          },
          [
            _c("div", { staticClass: "title" }, [_vm._v("总列数")]),
            _c("el-input", {
              attrs: { clearable: "", placeholder: "请输入" },
              model: {
                value: _vm.value.config.total_cols,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "total_cols", $$v)
                },
                expression: "value.config.total_cols",
              },
            }),
          ],
          1
        ),
      ],
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.setCategory()
            },
          },
        },
        [_vm._v("设置和预览全部分类")]
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.categoryDialog,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: "设置和预览全部分类",
            top: "50px",
            width: "55rem",
            "custom-class": "categoryDialog",
            center: "",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryDialog = $event
            },
          },
        },
        [
          _vm.categoryDialog
            ? _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dialogLoading,
                      expression: "dialogLoading",
                    },
                  ],
                  ref: "dialogForm",
                  staticClass: "dialogForm",
                  style: _vm.Styles,
                  attrs: {
                    model: _vm.dialogForm,
                    disabled: _vm.disabled,
                    rules: _vm.dialogRules,
                    "label-width": "6rem",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "总列数",
                        prop: "total_cols",
                        "label-width": "9rem",
                        rules: [
                          {
                            required: true,
                            validator: function (rule, val, callback) {
                              return _vm.checkTotalCols(
                                rule,
                                val,
                                _vm.dialogForm.cols,
                                callback
                              )
                            },
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.dialogForm.total_cols,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "total_cols", $$v)
                          },
                          expression: "dialogForm.total_cols",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "单屏显示列数",
                        prop: "cols",
                        "label-width": "9rem",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { disabled: _vm.dialogForm.type === 3 },
                          model: {
                            value: _vm.dialogForm.cols,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "cols", $$v)
                            },
                            expression: "dialogForm.cols",
                          },
                        },
                        _vm._l(_vm.colsList, function (col) {
                          return _c("el-option", {
                            key: col.value,
                            attrs: { label: col.label, value: col.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "行数是否开启折叠",
                        prop: "is_open_row_fold",
                        "label-width": "9rem",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.dialogForm.is_open_row_fold,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "is_open_row_fold", $$v)
                            },
                            expression: "dialogForm.is_open_row_fold",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("关闭"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("开启"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.dialogForm.is_open_row_fold === "1"
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "fold_start_row",
                              label: "折叠起始行",
                              "label-width": "9rem",
                            },
                          },
                          [
                            _c("el-input-number", {
                              attrs: { size: "small", min: 2 },
                              model: {
                                value: _vm.dialogForm.fold_start_row,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dialogForm,
                                    "fold_start_row",
                                    $$v
                                  )
                                },
                                expression: "dialogForm.fold_start_row",
                              },
                            }),
                            _c("span", { staticClass: "tips" }, [
                              _vm._v(
                                "如填写3，表示默认展示前2行，第3行及后续都要点击展开查看"
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "展开按钮文案",
                              prop: "expand_btn_text",
                              "label-width": "9rem",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: _vm.dialogForm.expand_btn_text,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dialogForm,
                                    "expand_btn_text",
                                    $$v
                                  )
                                },
                                expression: "dialogForm.expand_btn_text",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "收起按钮文案",
                              prop: "fold_btn_text",
                              "label-width": "9rem",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: _vm.dialogForm.fold_btn_text,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "fold_btn_text", $$v)
                                },
                                expression: "dialogForm.fold_btn_text",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          " 点击各个分类设置跳转功能和图片，虚线表示理论上的屏幕界限 "
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.addForm },
                        },
                        [_vm._v(" 新增分类 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            animation: "500",
                            id: "draggableCenter",
                            "force-fallback": true,
                          },
                          model: {
                            value: _vm.dialogForm.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "value", $$v)
                            },
                            expression: "dialogForm.value",
                          },
                        },
                        _vm._l(_vm.dialogForm.value, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: [
                                "box",
                                index === _vm.currentCategoryIndex && "current",
                                _vm.errorIndex.includes(index) && "error",
                                _vm.generateClass(index),
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.chooseItem(item, index)
                                },
                              },
                            },
                            [
                              _c(
                                "el-image",
                                {
                                  staticClass: "img",
                                  attrs: { src: item.imageurl, fit: "contain" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [_c("i", { staticClass: "el-icon-more" })]
                                  ),
                                ]
                              ),
                              _c("i", {
                                staticClass: "el-icon el-icon-close",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleDelUpload(index)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.dialogForm.value, function (item, formItemIndex) {
                    return [
                      formItemIndex === _vm.currentCategoryIndex
                        ? _c(
                            "div",
                            { key: formItemIndex, staticClass: "categoryBox" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "box",
                                  attrs: {
                                    prop: "value." + formItemIndex + ".name",
                                    rules:
                                      _vm.dialogForm.type === 3
                                        ? []
                                        : [
                                            {
                                              required: true,
                                              message: "菜单名称不可为空",
                                              trigger: "change",
                                            },
                                          ],
                                    label: "分类名称",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: item.name,
                                      callback: function ($$v) {
                                        _vm.$set(item, "name", $$v)
                                      },
                                      expression: "item.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "box upload-box",
                                  attrs: {
                                    prop:
                                      "value." + formItemIndex + ".imageurl",
                                    rules: [
                                      {
                                        required: true,
                                        message: "菜单图片不可为空",
                                        trigger: "change",
                                      },
                                    ],
                                    label: "分类图片",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "upload" },
                                    [
                                      _c("upload-file", {
                                        ref: "uploadBanner",
                                        refInFor: true,
                                        attrs: {
                                          "link-url": _vm.linkUrl,
                                          tempurl: item.imageurl,
                                          uploadInfo: _vm.uploadInfo,
                                        },
                                        on: {
                                          emitUploadFile: function (res) {
                                            return _vm.emitUploadFile(res, item)
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "upload-item-wrap" },
                                        [
                                          _c(
                                            "el-button",
                                            { on: { click: _vm.onUpload } },
                                            [_vm._v(" 上传图片 ")]
                                          ),
                                          _vm.pictureInfo[1]
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectPicture(
                                                        1,
                                                        _vm.currentCategoryIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 选择图片 ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "box config-menu",
                                  attrs: { label: "跳转功能", required: "" },
                                },
                                [
                                  _c("config-menu", {
                                    key: item.uid,
                                    attrs: {
                                      value: item,
                                      index: formItemIndex,
                                      type: _vm.value.key,
                                      info: _vm.info,
                                      menuList: _vm.menuList,
                                      childrenMenuList: _vm.childrenMenuList,
                                      customerModuleList:
                                        _vm.customerModuleList,
                                      eBookCategoryList: _vm.eBookCategoryList,
                                      aBookCategoryList: _vm.aBookCategoryList,
                                      customerPackageList:
                                        _vm.customerPackageList,
                                      systemMenus: _vm.systemMenus,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.dialogForm.enable_dynamic_tags === "1"
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "box",
                                      attrs: {
                                        prop:
                                          "value." +
                                          formItemIndex +
                                          ".dynamic_tag",
                                        label: "动态标签",
                                        rules: [
                                          {
                                            validator: function (
                                              rule,
                                              value,
                                              callback
                                            ) {
                                              return _vm.checkAmount(
                                                rule,
                                                value,
                                                callback
                                              )
                                            },
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请输入动态标签文案",
                                        },
                                        model: {
                                          value: item.dynamic_tag,
                                          callback: function ($$v) {
                                            _vm.$set(item, "dynamic_tag", $$v)
                                          },
                                          expression: "item.dynamic_tag",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.dialogLoading },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(" 完 成 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }